// Header (foto + corona + logo + marquesina + menú) y footer (contador + produce + redes)
import React, { useEffect, useState } from "react";
import { EVENT_DATE, INSTAGRAM_URL, TIKTOK_URL, SPOTIFY_URL, SHOW_SECTORES, SHOW_PERMISO, SHOW_LINEUP, ENTRADAS_URL, MENU_ONLINE, SHOW_PUNTOS } from "./config";

// Objetos entregados por diseño (Landing/images) → src/assets/qlk26/v2
import logo from "../../assets/qlk26/v2/logo.png";
import corona from "../../assets/qlk26/v2/corona.png";
import fecha from "../../assets/qlk26/v2/fecha-v4.png"; // 6 y 7 de Diciembre · Jockey Club - Río Cuarto
import marquesina from "../../assets/qlk26/v2/marquesina-tile.png";
// versión celular: recortada al texto, así en la misma franja la letra se ve más grande
import marquesinaMobile from "../../assets/qlk26/v2/marquesina-tile-m.png";
import menuElFesti from "../../assets/qlk26/v2/menu-elfesti.png";
import menuLineUp from "../../assets/qlk26/v2/menu-lineup.png";
import menuEntradas from "../../assets/qlk26/v2/menu-entradas.png";
import menuPuntos from "../../assets/qlk26/v2/menu-puntos.png";
import menuContacto from "../../assets/qlk26/v2/menu-contacto.png";
import menuSectores from "../../assets/qlk26/v2/menu-sectores.png";
import produce from "../../assets/qlk26/v2/produce.png";
import footerIg from "../../assets/qlk26/v2/ig.png";
import footerTiktok from "../../assets/qlk26/v2/tiktok.png";
// Extraído del PDF (todavía sin objeto propio)
import faltan from "../../assets/qlk26/faltan.png";

// Medidas en px del lienzo de 1920 (los objetos vienen exportados a ese ancho).
const px = (x) => `calc(var(--px) * ${x})`;

// Menú: img = botón del diseño; si todavía no hay imagen se muestra texto.
// Para SECTORES / PERMISO: importar la imagen y ponerla en `img`.
// side: a qué lado del logo va en desktop.
export const MENU = [
  { id: "festi", label: "EL FESTI", img: menuElFesti, side: "left" },
  { id: "lineup", label: "LINE UP", img: menuLineUp, side: "left", disabled: !SHOW_LINEUP },
  { id: "entradas", label: "ENTRADAS", img: menuEntradas, side: "left" },
  { id: "puntos", label: "PUNTOS DE VENTA", img: menuPuntos, side: "left" },
  { id: "sectores", label: "SECTORES", img: menuSectores, side: "right" },
  { id: "online", label: "COMPRA ONLINE", img: null, side: "right", href: ENTRADAS_URL },
  { id: "permiso", label: "PERMISO", img: null, side: "right" },
  { id: "contacto", label: "CONTACTO", img: menuContacto, side: "right" },
].filter(
  (m) =>
    (m.id !== "sectores" || SHOW_SECTORES) &&
    (m.id !== "permiso" || SHOW_PERMISO) &&
    (m.id !== "puntos" || SHOW_PUNTOS) &&
    (m.id !== "online" || MENU_ONLINE)
);

export const SpotifyIcon = ({ color = "currentColor", bg = "none" }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    {bg !== "none" && <circle cx="12" cy="12" r="12" fill={bg} />}
    <path
      fill={color}
      d="M17.9 10.9C14.7 9 9.35 8.8 6.3 9.75c-.5.15-1-.15-1.15-.6-.15-.5.15-1 .6-1.15 3.55-1.05 9.4-.85 13.1 1.35.45.25.6.85.35 1.3-.25.35-.85.5-1.3.25zm-.1 2.8c-.25.35-.7.5-1.05.25-2.7-1.65-6.8-2.15-9.95-1.15-.4.1-.85-.1-.95-.5-.1-.4.1-.85.5-.95 3.65-1.1 8.15-.55 11.25 1.35.3.15.45.65.2 1zm-1.2 2.75c-.2.3-.55.4-.85.2-2.35-1.45-5.3-1.75-8.8-.95-.35.1-.65-.15-.75-.45-.1-.35.15-.65.45-.75 3.8-.85 7.1-.5 9.7 1.1.35.15.4.55.25.85z"
    />
  </svg>
);

class Header26 extends React.Component {
  state = { open: false, scrolled: false };

  // En celular el logo es grande arriba de todo (sobre la foto de la home) y se achica
  // al scrollear, para no tapar los títulos de las secciones.
  componentDidMount() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  }

  onScroll = () => {
    const scrolled = window.scrollY > 40;
    if (scrolled !== this.state.scrolled) this.setState({ scrolled });
  };

  go = (id) => {
    this.setState({ open: false });
    this.props.onNavigate(id);
  };

  renderItem(item, tabIndex) {
    const cls = this.props.active === item.id ? " is-active" : "";
    if (item.href) {
      // botón que abre un link externo (ONLINE → venta online)
      return (
        <a
          key={item.id}
          className={item.img ? "q26-nav-btn q26-nav-link" : "q26-nav-txt q26-nav-link-txt"}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={item.label}
          tabIndex={tabIndex}
          onClick={() => this.setState({ open: false })}
        >
          {item.img ? <img src={item.img} alt={item.label} /> : item.label}
        </a>
      );
    }
    if (item.disabled) {
      // se ve en el menú pero todavía no lleva a ningún lado
      return (
        <span key={item.id} className="q26-nav-btn is-disabled" aria-disabled="true" title="Próximamente">
          <img src={item.img} alt={item.label} />
        </span>
      );
    }
    if (item.img) {
      return (
        <button
          key={item.id}
          className={"q26-nav-btn" + cls}
          onClick={() => this.go(item.id)}
          aria-label={item.label}
          tabIndex={tabIndex}
        >
          <img src={item.img} alt={item.label} />
        </button>
      );
    }
    return (
      <button key={item.id} className={"q26-nav-txt" + cls} onClick={() => this.go(item.id)} tabIndex={tabIndex}>
        {item.label}
      </button>
    );
  }

  render() {
    const { open } = this.state;
    const tiles = [0, 1, 2, 3, 4, 5];

    return (
      <header className={"q26-header" + (this.state.scrolled ? " is-scrolled" : "")}>
        <div className="q26-header-photo" />
        <img className="q26-abs q26-corona" src={corona} alt="" style={{ left: px(31), top: 0, width: px(307) }} />
        <img
          className="q26-abs q26-fecha"
          src={fecha}
          alt="6 y 7 de Diciembre · Jockey Club - Río Cuarto, Córdoba"
          style={{ left: px(1290), top: px(38), width: px(567) }}
        />

        {/* Marquesina rosa: la imagen se repite y se desplaza en loop; click → Spotify */}
        <a
          className="q26-marquee"
          href={SPOTIFY_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Escuchar en Spotify"
        >
          <div className="q26-marquee-track">
            {tiles.map((i) => (
              <picture key={i}>
                <source media="(max-width: 768px)" srcSet={marquesinaMobile} />
                <img src={marquesina} alt="" />
              </picture>
            ))}
          </div>
        </a>

        <nav className="q26-nav">
          <div className="q26-nav-side left">
            {MENU.filter((m) => m.side === "left").map((m) => this.renderItem(m))}
          </div>
          <div className="q26-nav-side right">
            {MENU.filter((m) => m.side === "right").map((m) => this.renderItem(m))}
          </div>
        </nav>

        <button className="q26-logo-btn" onClick={() => this.go("home")} aria-label="Inicio">
          <img src={logo} alt="QLK Fest 2da edición" />
        </button>

        {/* Mobile */}
        <button
          className={"q26-burger" + (open ? " is-open" : "")}
          onClick={() => this.setState({ open: !open })}
          aria-label="Menú"
          aria-expanded={open}
        >
          <span />
          <span />
          <span />
        </button>
        <nav className={"q26-mobile-menu" + (open ? " is-open" : "")} aria-hidden={!open}>
          {MENU.map((m) => this.renderItem(m, open ? 0 : -1))}
        </nav>
      </header>
    );
  }
}

// ---------- Contador ----------
function diff() {
  const ms = Math.max(0, EVENT_DATE.getTime() - Date.now());
  const s = Math.floor(ms / 1000);
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    s: s % 60,
  };
}
export function Countdown() {
  const [t, setT] = useState(diff());
  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);
  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div className="q26-countdown" role="timer" aria-label="Cuenta regresiva">
      <div>
        <b>{t.d}</b>
        <small>Días</small>
      </div>
      <div>
        <b>{pad(t.h)}</b>
        <small>Horas</small>
      </div>
      <div>
        <b>{pad(t.m)}</b>
        <small>Minutos</small>
      </div>
      <div>
        <b>{pad(t.s)}</b>
        <small>Segundos</small>
      </div>
    </div>
  );
}

export function Faltan({ hidden }) {
  return (
    <div className={"q26-faltan-group" + (hidden ? " is-hidden" : "")}>
      <img src={faltan} alt="Faltan" style={{ width: px(232) }} />
      <Countdown />
    </div>
  );
}

export function Footer26({ showCountdown }) {
  return (
    <footer className="q26-footer">
      <div className="q26-footer-inner">
        <div className="q26-abs" style={{ left: px(40), top: px(35) }}>
          <Faltan hidden={!showCountdown} />
        </div>
        <img
          className="q26-abs q26-produce"
          src={produce}
          alt="Produce: Artes Group y Q'Lokura"
          style={{ left: px(759), top: px(29), width: px(400) }}
        />
        <a
          className="q26-abs q26-social"
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ left: px(1542), top: px(42), width: px(128) }}
        >
          <img src={footerIg} alt="Instagram @qlkfest" style={{ width: "100%" }} />
        </a>
        <a
          className="q26-abs q26-social"
          href={TIKTOK_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ left: px(1708), top: px(42), width: px(121) }}
        >
          <img src={footerTiktok} alt="TikTok @qlkfest" style={{ width: "100%" }} />
        </a>
      </div>
    </footer>
  );
}

export default Header26;
